<template>
	<v-row no-gutters justify="center" v-if="blockData" @click.stop="clickBlock" class="flow-tree-block">
		<FlowTreeBlockContainer
			v-on="$listeners"
			:action-data="actionData"
			:app-data="appData"
			:original-app-data="originalAppData"
			:block-data="blockData"
			:is-chosen="isChosen"
			:is-first-block="isFirstBlock"
			:is-contextual-block="isContextualBlock"
			:disabled="isDisabled"
			:isFinalEndRunBlock="isFinalEndRunBlock"
			:isUnreachable="!isNodeReachable"
		/>
		<div v-if="debugBackgroundColor" class="debug-indication" :style="{ background: debugBackgroundColor }" />
	</v-row>
</template>

<script>
import FlowTreeBlockContainer from './FlowTreeBlockContainer.vue';
import { useIsNodeReachable } from '@/store/modules/treeBlocks/getters';
import { isSelectingWorkflowRoute } from '@/store/modules/workflowGraphs/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import * as WorkflowNodeService from '@/utils/workflow-node-service';

export default {
	name: 'FlowTreeBlock',
	components: {
		FlowTreeBlockContainer,
	},
	props: {
		blockData: { type: Object, required: true },
		isActive: { type: Boolean, required: false },
		isFirstBlock: { type: Boolean, default: false },
		isChosen: { type: Boolean },
		actionData: { type: Object },
		appData: { type: Object },
		isContextualBlock: { type: Boolean },
		disabled: { type: Boolean },
		isFinalEndRunBlock: { type: Boolean },
		originalAppData: { type: Object },
		debugBackgroundColor: { type: String },
	},
	data() {
		return {};
	},
	computed: {
		...mapGettersShorthand({ useIsNodeReachable, isSelectingWorkflowRoute }),
		isNodeReachable() {
			return WorkflowNodeService.isNodeTemp(this.blockData) || this.useIsNodeReachable({ node: this.blockData });
		},
		isLoopEnd() {
			return WorkflowNodeService.isLoopEnd(this.blockData, this.actionData);
		},
		isDisabled() {
			const disabledLoopEnd = this.isLoopEnd && !this.isSelectingWorkflowRoute;
			return this.disabled || disabledLoopEnd;
		},
	},
	methods: {
		clickBlock(event) {
			if (this.isNodeReachable && !this.isDisabled) {
				event.preventDefault();
				this.$emit('clickBlock', Object.assign({}, this.blockData));
			}
		},
	},
};
</script>

<style scoped lang="scss">
.debug-indication {
	width: 100%;
	opacity: 0.15;
	position: absolute;
	border-radius: 10px;
	height: calc(100% - 50px);
}
</style>
